import { render } from "./AddBoat.vue?vue&type=template&id=20771677"
import script from "./AddBoat.vue?vue&type=script&lang=js"
export * from "./AddBoat.vue?vue&type=script&lang=js"
script.render = render

export default script